export type BoundedPollStartedAtRef = {
	current: number | null;
};

/** Caps the whole watch so dead jobs or missed events cannot poll for the lifetime of the page. */
export const boundedPoll = <T>({
	data,
	shouldPoll,
	startedAtMsRef,
	intervalMs,
	maxMs,
	nowMs = Date.now(),
}: {
	data: T;
	shouldPoll: (data: T) => boolean;
	startedAtMsRef: BoundedPollStartedAtRef;
	intervalMs: number;
	maxMs: number;
	nowMs?: number;
}): number | false => {
	if (!shouldPoll(data)) {
		startedAtMsRef.current = null;
		return false;
	}
	if (startedAtMsRef.current === null) {
		startedAtMsRef.current = nowMs;
	}
	if (nowMs - startedAtMsRef.current >= maxMs) {
		return false;
	}
	return intervalMs;
};
